import isEmpty from 'ramda/src/isEmpty';
import pathSatisfies from 'ramda/src/pathSatisfies';
import i18n from 'invision-core/src/components/i18n/i18n';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import CustomerCareKeys from '../../../../../../../locales/keys';
export var getProductPriceLabel = function getProductPriceLabel(product) {
  return hasPriceInfo(product) ? "".concat(i18n.translate(CustomerCareKeys.FEATURED_PRICE)) : '';
};
export var getProductPrice = function getProductPrice($filter, product) {
  if (hasBrandableCurrencyInfo(product)) {
    return "".concat(product.ProductContext.FeaturedOrderablePricingPlan.Amount || 0, " ").concat(product.ProductContext.FeaturedOrderablePricingPlan.BrandableCurrencyName);
  }
  if (hasPriceInfo(product)) {
    return "".concat($filter('invCurrency')(product.ProductContext.FeaturedOrderablePricingPlan.Amount || 0, product.ProductContext.FeaturedOrderablePricingPlan.Currency));
  }
  return '';
};
export var hasPriceInfo = function hasPriceInfo(product) {
  return product.ProductClassification === PRODUCT_CLASSIFICATIONS.AD_HOC || product.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE ? false : pathSatisfies(function (featuredPlan) {
    return featuredPlan !== undefined && !isEmpty(featuredPlan);
  }, ['ProductContext', 'FeaturedOrderablePricingPlan'], product);
};
var hasBrandableCurrencyInfo = function hasBrandableCurrencyInfo(product) {
  return pathSatisfies(function (featuredPlan) {
    return featuredPlan !== undefined && !isEmpty(featuredPlan);
  }, ['ProductContext', 'FeaturedOrderablePricingPlan', 'BrandableCurrency'], product);
};